import React from "react";

import Link from "next/link";
import Image from "next/image";
import bethelp24Logo from "@/images/logo/no-488-bg.png"
export interface LogoProps {
  img?: string;
  imgLight?: string;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({

  className = "flex-shrink-0",
}) => {
  return (
    <Link
      href="/"
      className={`   ${className}`}
    >
      <Image
       
          src={bethelp24Logo}
          alt="Logo-Light"
         width={180}
         height={180}
         
        />
    </Link>
  );
};

export default Logo;
